import './Theme.EventCalendar.Datepicker.scss';
export default 'ThemeEventCalendarDatepicker';
